<template>
  <v-row class="pa-0">
    <v-col cols="12" md="8" :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;line-height:2;">
      تعريف عن شركة أرامكو
    </v-col>
    <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;line-height:2;">
      <v-btn 
        :class="`${arabic?'arFont':'enFont'}`" 
        block 
        large
        :loading="loading"
        @click="scrollDown()"
        color="success">
        خدمات ارامكو
      </v-btn>
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
      شركة أرامكو في ألمانيا هي شركة ألمانية عربية مقرها الرئيسي بمدينة شتوتغارت في ألمانيا تأسست عام 2012 ، تعد شركة أرامكو جسرا بين العالم العربي وألمانيا وتقدم خدماتها لملتحقيها من الوطن العربي بمختلف المجالات
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
      <v-icon>radio_button_checked</v-icon>
      برنامج الدراسة المزدوجة بألمانيا .
      <br><v-icon>radio_button_checked</v-icon>
      برنامج عمل الممرضين والممرضات ومساعدين التمريض في ألمانيا.
      <br><v-icon>radio_button_checked</v-icon>
      برنامج عمل المهندسين بألمانيا .
      <br><v-icon>radio_button_checked</v-icon>
      برنامج عمل واختصاص الأطباء وأطباء الأسنان والصيادلة بألمانيا.
      <br><v-icon>radio_button_checked</v-icon>
      برنامج الدراسة الجامعية في المانيا.
      <br><v-icon>radio_button_checked</v-icon>
      برنامج عمل التقنيين (المهنيين – الفنيين) في المانيا
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;line-height:2;">
      فروع ووكلاء ارامكو
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
      يوجد لدى ارامكو فروع ووكلاء في كل من الدول التالية:
      <br><v-icon>radio_button_checked</v-icon>
      مصر 
      <br><v-icon>radio_button_checked</v-icon>
      المغرب
      <br><v-icon>radio_button_checked</v-icon>
      تونس 
      <br><v-icon>radio_button_checked</v-icon>
      الجزائر 
      <br><v-icon>radio_button_checked</v-icon>
      فلسطين 
      <br><v-icon>radio_button_checked</v-icon>
      الأردن
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;line-height:2;" id="services">
      الخدمات المقدمة من قبل شركة أرامكو في المانيا 
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
      <v-row class="pa-0" v-if="lead.program_name.slug == 'ausbildung'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو قبل القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          التقييمات اللغوية للملتحق: يقوم فريق الماني خاص بالشركة في متابعة الملتحقين بشكل دوري ليعطي الملتحقين معرفة أفضل بمستواهم اللغوي وتطوره بشكل أفضل
          <br><v-icon>radio_button_checked</v-icon>
          توفير قبول الدراسة المزدوجة من عام 2012 وشركة أرامكو بفريقها الأكاديمي المتخصص وهو يحقق الكثير فيما يتعلق بتوفير القبولات المناسبة للطالب
          <br><v-icon>radio_button_checked</v-icon>
          توفير السكن المجاني يقوم الفريق المتخصص بإيجاد القبولات وضمن القبول توفير سكن مجاني للطالب مما يجعل تركيز الطالب على دراسته فقط
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الطالب لمقابلة السفارة بعد حصول الطالب على قبول الدراسة المزدوجة يقوم وكيل أرامكو في البلد الأم للملتحق بتجهيز جميع أوراق الطالب للمقابلة في السفارة وفقا لتعليمات شركة أرامكو
          <br><v-icon>radio_button_checked</v-icon>
          تأمين موافقة وزارة العمل يقوم فريق أرامكو في ألمانيا بتأمين موافقة وزارة العمل للملتحق مما يتيح له الحصول بشكل سريع على الفيزا

        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو بعد القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          استقبال الملتحق في المطار يتم استقبال الملتحق في المطار من قبل فريق أرامكو وايصالهم الى السكنات المخصصة
          <br><v-icon>radio_button_checked</v-icon>
          تسليم الملتحق السكن الخاص به توفر أرامكو للملتحقين معها سكنات خاصة لهم خلال فترة دراسة اللغة مما يوفر جهد ووقت كبير للطالب بالاهتمام بدراسة اللغة
          <br><v-icon>radio_button_checked</v-icon>
          خدمات أخرى لشركة أرامكو يقوم فريق أرامكو بتوفير الأمور الازمة للملتحقين من شريحة الهاتف الى تسجيل في الدوائر الألمانية وتمديد الإقامة للملتحق
          <br><v-icon>radio_button_checked</v-icon>
          توجيه الملتحق الى معهد اللغة يتم توجيه الملتحق الى معهد اللغة للبدء بالكورسات التي يجب عليه دراستها
          <br><v-icon>radio_button_checked</v-icon>
          الحاق الطالب بالجامعات الألمانية بعد الانتهاء من دراسة كورسات اللغة لطالب وتأكد شركة أرامكو من جاهزيته يتم توصيله لأقرب منطقة من تواجد مكان المركز الذي سيقوم بالدراسة به
        </v-col>
      </v-row>
      <v-row class="pa-0" v-if="lead.program_name.slug == 'students'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو قبل القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          مقابلة شخصية عبر zoom دراسة ملف الطالب وتقديم جميع النصائح والتوجيهات له بخصوص ملفه وذالك من خلال مقابلة شخصية عبر السكايب مع فريق قسم الطلاب في ألمانيا.
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الجامعة مساعدة الطالب في تحضير الملف الجامعي الخاص به من ترجمة وتصديق الأوراق والشهادات الرسمية وإرسال جميع هذه المستندات لفرع أرامكو الرئيسي في ألمانيا .
          <br><v-icon>radio_button_checked</v-icon>
          تأمين قبول جامعي من عام 2012 وشركة أرامكو بفريقها الأكاديمي المتخصص وهو يحقق الكثير فيما يتعلق بتوفير العقود المناسبة للطالب حسب التخصص الذي يرغب به الطالب .
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الطالب لمقابلة السفارة بعد حصول الطالب على المقعد الجامعي يقوم وكيل أرامكو في البلد الأم للملتحق بتجهيز جميع أوراق الطالب للمقابلة في السفارة وفقا لتعليمات شركة أرامكو .
          <br><v-icon>radio_button_checked</v-icon>
          دراسة اللغة تسجيل الطالب في معهد اللغة في ألمانيا لدراسة المستوي الثالث والرابع في اللغة الألمانية ( B1 , B2), حيث أن هذه الدورات مكثفة ومدة كل كورس تبلغ شهرين.
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو بعد القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          استقبال الملتحق في المطار يتم استقبال الملتحق في المطار من قبل فريق أرامكو وايصالهم الى السكنات المخصصة .
          <br><v-icon>radio_button_checked</v-icon>
          تسليم الملتحق السكن الخاص به توفر أرامكو للملتحقين معها سكنات خاصة لهم خلال فترة دراسة اللغة مما يوفر جهد ووقت كبير للطالب بالاهتمام بدراسة اللغة .
          <br><v-icon>radio_button_checked</v-icon>
          خدمات أخرى لشركة أرامكو يقوم فريق أرامكو بتوفير الأمور اللازمة للملتحقين من - شريحة الهاتف - تسجيل الطالب في دائرة السكن - فتح الحساب البنكي للطالب - عمل التأمين الصحي للطالب - تمديد الإقامة لدى دائرة الأجانب .
          <br><v-icon>radio_button_checked</v-icon>
          توجيه الملتحق الى معهد اللغة يتم توجيه الملتحق الى معهد اللغة للبدء بالكورسات التي يجب عليه دراستها .
          <br><v-icon>radio_button_checked</v-icon>
          متابعة الطالب لغويا حتى الدخول للجامعة.
        </v-col>
      </v-row>
      <v-row class="pa-0" v-if="lead.program_name.slug == 'engineers'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو قبل القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          مقابلة شخصية عبر السكايب: يتم اجراء مقابلة zoom مع المهندس الراغب بالعمل في المانيا لشرح البرنامج وشروط العمل في المانيا من قبل فريق عمل أرامكو
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الملتحق: بعد توقيع الملتحق لعقد ارامكو يتم تزويد الملتحق بقائمة الاوراق والشهادات الرسمية التي يجب على الملتحق ترجمتها وتصديقها
          <br><v-icon>radio_button_checked</v-icon>
          يبدأ الملتحق دراسة اللغة الألمانية في البلد الأم ( B1+A2 + A1) - تسجيل الملتحق في معهد اللغة في ألمانيا لدراسة المستوي الرابع في اللغة الألمانية (B2)، حيث أن هذه الدورة مكثفة ومدة كل كورس تبلغ شهرين.
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز الملتحق للحصول على عقد العمل بعد الانتهاء من معادلة شهادة المهندس يتم البدء بتجهيز المهندس للمقابلات مع الشركات الألمانية للحصول على عقد العمل
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الملتحق لمقابلة السفارة بعد وصول الملتحق المستوى اللغوي المطلوب يقوم وكيل أرامكو في البلد الأم للملتحق بتجهيز جميع أوراق الطالب للمقابلة في السفارة وفقا لتعليمات شركة أرامكو
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو بعد القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          استقبال الملتحق في المطار يتم استقبال الملتحق في المطار من قبل فريق أرامكو وايصالهم الى السكنات المخصصة
          <br><v-icon>radio_button_checked</v-icon>
          تسليم الملتحق السكن الخاص به توفر أرامكو للملتحقين معها سكنات خاصة لهم خلال فترة دراسة اللغة مما يوفر جهد ووقت كبير للطالب بالاهتمام بدراسة اللغة
          <br><v-icon>radio_button_checked</v-icon>
          توجيه الملتحق الى معهد اللغة يتم توجيه الملتحق الى معهد اللغة للبدء بالكورسات التي يجب عليه دراستها
          <br><v-icon>radio_button_checked</v-icon>
          متابعة المهندس يتم متابعة سير دراسة اللغة للمهندس مع تزويد المهندس بمعلومات خاصة بالحياة في المانيا مما يسهل عليه الاندماج بشكل سريع مع المجتمع الالماني
        </v-col>
      </v-row>
      <v-row class="pa-0" v-if="lead.program_name.slug == 'doctors'">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو قبل القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          مقابلة شخصية عبر السكايب: يتم اجراء مقابلة zoom مع الطبيب الراغب بالعمل في المانيا لشرح البرنامج وشروط العمل في المانيا من قبل فريق عمل أرامكو
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الطبيب : بعد توقيع الطبيب لعقد ارامكو يتم تزويد الملتحق بقائمة الاوراق والشهادات الرسمية التي يجب على الملتحق ترجمتها وتصديقها وارساله الى لأرامكو. تقوم أرامكو بمعادلة شهادات الطبيب خلال فترة 8-12 أسبوع
          <br><v-icon>radio_button_checked</v-icon>
          دراسة اللغة - يبدأ الطبيب دراسة اللغة الألمانية في البلد الأم (A1 - A2) - تسجيل الطبيب في معهد اللغة في ألمانيا لدراسة المستوي الثالث والرابع في اللغة الألمانية
          <br><v-icon>radio_button_checked</v-icon>
          تجهيز ملف الملتحق لمقابلة السفارة بعد وصول الملتحق المستوى اللغوي المطلوب يقوم وكيل أرامكو في البلد الأم للملتحق بتجهيز جميع أوراق الطالب للمقابلة في السفارة وفقا لتعليمات شركة أرامكو
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:18px;line-height:2;">
          خدمات شركة أرامكو بعد القدوم الى المانيا
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
          <v-icon>radio_button_checked</v-icon>
          إستقبال الطبيب في المطار يتم استقبال الطبيب في المطار من قبل فريق أرامكو وايصالهم الى السكنات المخصصة
          <br><v-icon>radio_button_checked</v-icon>
          تسليم الطبيب السكن الخاص به توفر أرامكو للأطباء الملتحقين معها سكنات خاصة لهم خلال فترة دراسة اللغة مما يوفر جهد ووقت كبير للطبيب بلإهتمام بدراسة اللغة
          <br><v-icon>radio_button_checked</v-icon>
          خدمات أخرى لشركة أرامكو يقوم فريق أرامكو بتوفير الأمور اللازمة للأطباء الملتحقين من - شريحة الهاتف - تسجيل الطبيب في دائرة السكن - فتح الحساب البنكي للطبيب - عمل التأمين الصحي للطبيب - تمديد الإقامة لدى دائرة الأجانب
          <br><v-icon>radio_button_checked</v-icon>
          توجيه الطبيب الى معهد اللغة يتم توجيه الملتحق الى معهد اللغة للبدء بالكورسات التي يجب عليه دراستها
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:16px;line-height:2;">
      <iframe width="100%" height="315" src="https://www.youtube.com/embed/aLIfBC-gLoY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props:['loading', 'arabic', 'view', 'lead', 'confirmed'],
  data(){
    return {
    }
  },
  methods:{
    scrollDown() {
      this.$vuetify.goTo('#services')
    },
  },
  computed:{
    
  }
}
</script>

<style>

</style>